const radioButtons = document.querySelectorAll('input[type="radio"]');

radioButtons.forEach((radioButton) => {
    radioButton.addEventListener('change', () => {
        const inputName = radioButton.name;
        const inputValue = radioButton.value;
        localStorage.setItem(inputName, inputValue);
    });

    const savedValue = localStorage.getItem(radioButton.name);
    if (savedValue) {
        radioButton.checked = savedValue === radioButton.value;
    } else {
        radioButton.checked = true;
        localStorage.setItem(radioButton.name, radioButton.value);
    }
});

const resBtn = document.querySelector('#btnToResult');
if (resBtn){
    resBtn.addEventListener('click', () => {
        setTimeout(() => {
            const redirectUrl = resBtn.getAttribute('data-href');
            window.location.href = redirectUrl;
        }, "1000");
    });
}

